import React from 'react';

const EndpointsContext = React.createContext({
  //
});

export default EndpointsContext;
